/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_RegionsInputs */

const en_search_regions = /** @type {(inputs: Search_RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search regions...`)
};

const es_search_regions = /** @type {(inputs: Search_RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar regiones...`)
};

/**
* | output |
* | --- |
* | "Search regions..." |
*
* @param {Search_RegionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_regions = /** @type {((inputs?: Search_RegionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_RegionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_regions(inputs)
	return es_search_regions(inputs)
});